<div class="manage-menu-shell">
  @if (mobileSidebarOpen) {
    <button
      type="button"
      class="manage-menu-shell__backdrop"
      aria-label="Close sidebar"
      (click)="closeMobileSidebar()"
    ></button>
  }

  <aside
    class="manage-menu-shell__sidebar"
    [class.manage-menu-shell__sidebar--collapsed]="sidebarCollapsed"
    [class.manage-menu-shell__sidebar--mobile-open]="mobileSidebarOpen"
  >
    <app-dashboard-sidebar [collapsed]="sidebarCollapsed" />
  </aside>

  <div class="manage-menu-shell__content">
    <app-dashboard-header
      [title]="''"
      [subtitle]="''"
      [user]="user"
      [currentTime]="''"
      (menuToggle)="handleMenuToggle()"
    />

    <main class="manage-menu-page">
      <section class="manage-menu-page__heading">
        <div class="manage-menu-page__heading-copy">
          <h2 class="app-title-serif">Manage Menu</h2>
        </div>

        <button type="button" class="app-button app-button--primary manage-menu-page__add-button" (click)="openAddMenuModal()">
          <span class="manage-menu-page__add-icon">+</span>
          <span>Add New Menu</span>
        </button>
      </section>

      <section class="manage-menu-page__filters app-card">
        <form class="manage-menu-filters" [formGroup]="filterForm">
          <label class="app-form-field manage-menu-filters__field">
            <span class="app-form-label">Search</span>
            <div class="manage-menu-filters__search">
              <span class="manage-menu-filters__search-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="11" cy="11" r="7"></circle>
                  <path d="m20 20-3.5-3.5"></path>
                </svg>
              </span>
              <input class="app-form-input manage-menu-filters__search-input" type="text" placeholder="Search" formControlName="search" />
            </div>
          </label>

          <div>
            <button
              type="button"
              class="app-button app-button--secondary equal app-filter-actions__button"
              [disabled]="isLoading"
              (click)="clearFilters()"
            >
              Clear
            </button>
          </div>
        </form>
      </section>

      <section class="manage-menu-page__table app-card">
        <div class="manage-menu-page__table-wrap app-table-scroll">
          <table class="manage-menu-table">
            <thead>
              <tr>
                <th>S.No.</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('menu_name')" [attr.aria-label]="'Sort by Menu Name'"><span>Menu Name</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('menu_name')" [class.manage-sort-icon--descending]="isSortDescending('menu_name')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                <th>Menu URL</th>
<th><button type="button" class="manage-sort-button" (click)="toggleSort('menu_code')" [attr.aria-label]="'Sort by Menu Code'"><span>Menu Code</span><svg class="manage-sort-icon" [class.manage-sort-icon--ascending]="isSortAscending('menu_code')" [class.manage-sort-icon--descending]="isSortDescending('menu_code')" viewBox="0 0 12 16" aria-hidden="true"><path class="manage-sort-icon-up" d="M6 1 2 5h8L6 1Z"></path><path class="manage-sort-icon-down" d="m2 11 4 4 4-4H2Z"></path></svg></button></th>
                <th>Order By</th>
                <th>Actions</th>
              </tr>
            </thead>
              <tbody>
              @if (isLoading) {
                <tr>
                  <td colspan="9" class="manage-menu-page__empty-state">Loading menus...</td>
                </tr>
              } @else if (visibleMenuRows.length) {
                @for (menu of visibleMenuRows; track trackByTreeId($index, menu)) {
                  <tr [class.manage-menu-table__body-row--child]="isChildRow(menu)">
                    <td>{{ isChildRow(menu) ? '' : (menu.display_serial_no ?? menu.serial_no) }}</td>
                    <td>
                      <div class="manage-menu-table__menu-name" [class.manage-menu-table__menu-name--child]="isChildRow(menu)" [style.--menu-depth]="menu.depth">
                        @if (hasChildren(menu)) {
                          <button
                            type="button"
                            class="manage-menu-table__expand-button"
                            [attr.aria-expanded]="isExpanded(menu)"
                            [attr.aria-label]="isExpanded(menu) ? 'Collapse menu group' : 'Expand menu group'"
                            (click)="toggleMenuGroup(menu)"
                          >
                            <i
                              class="fa-solid manage-menu-table__expand-icon"
                              [class.fa-angle-up]="isExpanded(menu)"
                              [class.fa-angle-down]="!isExpanded(menu)"
                              aria-hidden="true"
                            ></i>
                          </button>
                        } @else {
                          <span class="manage-menu-table__expand-spacer" aria-hidden="true"></span>
                        }
                        <div class="manage-menu-table__menu-copy">
                          <span class="manage-menu-table__menu-title">
                            @if (isChildRow(menu)) {
                              <span class="manage-menu-table__menu-index">{{ menu.child_index }}.</span>
                            }
                            <span>{{ menu.menu_name }}</span>
                          </span>
                        </div>
                      </div>
                    </td>
                    <td><span class="manage-menu-table__cell-text" [title]="menu.menu_url ?? '-'">{{ menu.menu_url ?? '-' }}</span></td>
                    <td><span class="manage-menu-table__cell-text" [title]="menu.menu_code ?? '-'">{{ menu.menu_code ?? '-' }}</span></td>
                    <td><span class="manage-menu-table__cell-text" [title]="menu.order_by === null ? '-' : (menu.order_by + '')">{{ menu.order_by === null ? '-' : menu.order_by }}</span></td>
                    <td>
                      <div class="manage-menu-page__actions">
                        <div class="app-row-action-menu">
                          <details class="app-row-action-menu__details">
                            <summary class="app-row-action-menu__toggle" aria-label="Open menu actions">
                              <span class="app-row-action-menu__dots" aria-hidden="true">
                                <span></span>
                                <span></span>
                                <span></span>
                              </span>
                            </summary>
                            <div class="app-row-action-menu__dropdown">
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--view" (click)="openViewMenuModal(menu)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--view" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M2.5 12s3.5-6.5 9.5-6.5S21.5 12 21.5 12s-3.5 6.5-9.5 6.5S2.5 12 2.5 12Z"></path>
                                    <circle cx="12" cy="12" r="2.8"></circle>
                                  </svg>
                                </span>
                                <span>View</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--edit" (click)="openEditMenuModal(menu)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--edit" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="m4 20 4.5-1 11-11a2.1 2.1 0 0 0-3-3l-11 11L4 20Z"></path>
                                    <path d="m13.5 6.5 4 4"></path>
                                  </svg>
                                </span>
                                <span>Edit</span>
                              </button>
                              <button type="button" class="app-row-action-menu__item app-row-action-menu__item--danger app-row-action-menu__item--delete" (click)="openDeleteMenuModal(menu)">
                                <span class="app-row-action-menu__icon app-row-action-menu__icon--delete" aria-hidden="true">
                                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M3 6h18"></path>
                                    <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
                                    <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
                                    <path d="M10 10v6"></path>
                                    <path d="M14 10v6"></path>
                                  </svg>
                                </span>
                                <span>Delete</span>
                              </button>
                            </div>
                          </details>
                        </div>
                      </div>
                    </td>
                  </tr>
                }
              } @else {
                <tr>
                  <td colspan="9" class="manage-menu-page__empty-state">No menu records found</td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        @if (canShowPagination()) {
          <div class="manage-menu-page__pagination">
            <div class="manage-menu-page__pagination-summary">
              <span>{{ getPaginationLabel() }}</span>
            </div>

            <div class="manage-menu-page__pagination-actions">
              <button type="button" class="app-button app-button--secondary manage-menu-page__pagination-button" [disabled]="pagination.page_no <= 1 || isLoading" (click)="goToPreviousPage()">
                Previous
              </button>

              <div class="manage-menu-page__pagination-pages" aria-label="Pagination pages">
                @for (page of getPaginationItems(); track $index) {
                  @if (page === -1) {
                    <span class="manage-menu-page__pagination-ellipsis" aria-hidden="true">...</span>
                  } @else {
                    <button
                      type="button"
                      class="manage-menu-page__pagination-page"
                      [class.manage-menu-page__pagination-page--active]="pagination.page_no === page"
                      [disabled]="isLoading"
                      (click)="goToPage(page)"
                    >
                      {{ page }}
                    </button>
                  }
                }
              </div>

              <button type="button" class="app-button app-button--secondary manage-menu-page__pagination-button" [disabled]="pagination.page_no >= pagination.total_pages || isLoading || pagination.total_pages === 0" (click)="goToNextPage()">
                Next
              </button>
            </div>

            <label class="manage-menu-page__pagination-size">
              <span class="manage-menu-page__pagination-size-label">Rows per page</span>
              <select class="app-form-select manage-menu-page__pagination-select" [formControl]="pageSizeControl">
                @for (size of pageSizeOptions; track size) {
                  <option [ngValue]="size">{{ size }}/Page</option>
                }
              </select>
            </label>
          </div>
        }
      </section>
    </main>
  </div>

  @if (menuModalOpen) {
    <div class="app-modal-backdrop">
      <dialog class="app-modal manage-menu-modal" open>
        <div class="manage-menu-modal__header">
          <div>
            <h3 class="app-title-serif">{{ modalMode === 'edit' ? 'Edit Menu' : modalMode === 'view' ? 'View Menu' : 'Add New Menu' }}</h3>
          </div>

          <button type="button" class="app-button app-button--icon manage-menu-modal__close" aria-label="Close modal" (click)="closeMenuModal()">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.9" stroke-linecap="round">
              <path d="M6 6 18 18"></path>
              <path d="M18 6 6 18"></path>
            </svg>
          </button>
        </div>

        <form [formGroup]="menuForm" (ngSubmit)="saveMenu()">
          <div class="manage-menu-modal__body">
            <div class="manage-menu-modal__grid">
              <label class="app-form-field">
                <span class="app-form-label">Menu Name <span class="manage-menu-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="e.g., Manage Menu" formControlName="menu_name" />
                @if (isRequiredFieldInvalid('menu_name')) {
                  <section class="app-form-error">Menu name is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Menu URL</span>
                <input class="app-form-input" type="text" placeholder="Optional URL" formControlName="menu_url" />
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Menu Code <span class="manage-menu-modal__required">*</span></span>
                <input class="app-form-input" type="text" placeholder="e.g., MANAGE_MENU" formControlName="menu_code" />
                @if (isRequiredFieldInvalid('menu_code')) {
                  <section class="app-form-error">Menu code is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Order By <span class="manage-menu-modal__required"></span></span>
                <input class="app-form-input" type="number" min="0"  formControlName="order_by" />
              </label>

              @if (showPhaseColumns) {
                <label class="app-form-field">
                  <span class="app-form-label">Phase</span>
                  <select class="app-form-select" formControlName="phase">
                    <option [ngValue]="null">Select Phase</option>
                    @for (phaseOption of getPhaseOptions(); track phaseOption.value) {
                      <option [ngValue]="phaseOption.value">{{ phaseOption.label }}</option>
                    }
                  </select>
                </label>
              }

              <label class="app-form-field">
                <span class="app-form-label">Icon Class <span class="manage-menu-modal__required">*</span></span>
                <div class="manage-menu-modal__icon-input">
                  <span class="manage-menu-modal__icon-prefix" aria-hidden="true">
                    <i class="fa-solid" [ngClass]="menuForm.get('icon_class')?.value || 'fa-bars'"></i>
                  </span>
                  <span class="manage-menu-modal__icon-divider" aria-hidden="true"></span>
                  <input class="app-form-input manage-menu-modal__icon-control" type="text" placeholder="e.g., fa-gauge" formControlName="icon_class" />
                </div>
                @if (isRequiredFieldInvalid('icon_class')) {
                  <section class="app-form-error">Icon class is required</section>
                }
              </label>

              <label class="app-form-field">
                <span class="app-form-label">Parent Menu</span>
                <select class="app-form-select" formControlName="parent_menu_id">
                  <option [ngValue]="null">No Parent</option>
                  @for (parentMenu of getVisibleParentMenus(); track trackById($index, parentMenu)) {
                    <option [ngValue]="parentMenu.id">{{ parentMenu.menu_name }}</option>
                  }
                </select>
              </label>
            </div>
          </div>

          <div class="manage-menu-modal__footer">
            <button type="button" class="app-button app-button--secondary" (click)="closeMenuModal()">Cancel</button>
            @if (modalMode !== 'view') {
              <button type="submit" class="app-button app-button--primary">Save</button>
            }
          </div>
        </form>
      </dialog>
    </div>
  }

  @if (deleteModalOpen && selectedMenu) {
    <div class="app-modal-backdrop">
      <section class="app-modal app-modal--compact manage-menu-delete">
        <div class="manage-menu-delete__header">
          <div class="manage-menu-delete__icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
              <path d="M10 11v5"></path>
              <path d="M14 11v5"></path>
              <path d="M3 6h18"></path>
              <path d="M8 6V4.5A1.5 1.5 0 0 1 9.5 3h5A1.5 1.5 0 0 1 16 4.5V6"></path>
              <path d="M6 6l1 14a1.5 1.5 0 0 0 1.5 1.5h8A1.5 1.5 0 0 0 18 20L19 6"></path>
            </svg>
          </div>
          <div>
            <h3 class="app-title-serif">Delete Menu</h3>
            <p>This action cannot be undone</p>
          </div>
        </div>

        <p class="manage-menu-delete__copy">
          Are you sure you want to delete <strong>{{ selectedMenu.menu_name }}</strong>?
        </p>

        <div class="manage-menu-delete__footer">
          <button type="button" class="app-button app-button--secondary" (click)="closeDeleteModal()">Cancel</button>
          <button type="button" class="app-button app-button--danger" (click)="confirmDelete()">Confirm Delete</button>
        </div>
      </section>
    </div>
  }
</div>
